import { ApiUrl } from "../utils/modules";
import {header} from "../utils/modules";
class stripeServices {
  constructor(api) {
    this.api = api;
  }
  create(data,params) {
    return this.api.post(ApiUrl + "paiement/"+params, data,header('json') );
  }
 
}

export default stripeServices;
